"use client";

import React from "react";
import { ArrowDown, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroExtremeSection() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const handleScroll = () => {
    const element = document.getElementById("voipenterprisesystems");
    if (element) {
      element.scrollIntoView({
        behavior: "smooth"
      });
    }
  };
  return <section data-section-id="242087" id="services-overview" className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-background"></div>

      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.4)_100%)]"></div>

      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[repeating-linear-gradient(90deg,transparent,transparent_40px,var(--muted-foreground)_40px,var(--muted-foreground)_41px)]"></div>
      </div>

      <div ref={contentRef} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <Badge variant="outline" className="mb-8 border-primary text-primary bg-primary/5 backdrop-blur-md px-5 py-1.5 text-sm font-mono uppercase tracking-[0.2em] rounded-lg">
          <Zap className="w-4 h-4 mr-2 text-primary" />
          Kansas City IT Services
        </Badge>

        <h1 className="font-default text-6xl md:text-8xl lg:text-9xl font-extrabold uppercase tracking-tighter text-foreground drop-shadow-sm mb-6 leading-[0.9]">
          Reliable Connection <br className="hidden md:block" />
          <span className="text-primary drop-shadow-[0_0_15px_rgba(184,255,0,0.5)]">
            & Communications
          </span>
        </h1>

        <p className="text-lg md:text-2xl text-muted-foreground max-w-3xl mx-auto mb-12 font-default drop-shadow-none leading-relaxed">
          Expert IT field services for Kansas City contractors and MSPs. 
          From structured cabling to rack & stack, we provide the boots-on-the-ground 
          execution your mission-critical projects demand.
        </p>

        <Button size="lg" onClick={handleScroll} className="bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground font-bold text-lg px-10 py-7 rounded-sm uppercase tracking-widest shadow-xl transition-all hover:shadow-2xl hover:-translate-y-1 border-2 border-transparent">
          View Our Services
          <ArrowDown className="ml-3 w-6 h-6 animate-bounce" />
        </Button>
      </div>
    </section>;
}